import { render, staticRenderFns } from "./ModalVerification.vue?vue&type=template&id=095c6c88&"
import script from "./ModalVerification.vue?vue&type=script&lang=js&"
export * from "./ModalVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports